import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconInfoRed } from "../Images/icon_info_red.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const PlanExpiredBox = ({ closeModal }) => {
  return (
    <Box>
      <div className="hrz-wrapper">
        <div style={{ marginLeft: "184px" }}>
          <IconInfoRed width="32px" height="32px" />
        </div>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={closeModal} />
        </div>
      </div>

      <p
        className="bold-text center"
        style={{ fontSize: "24px", marginTop: "14px" }}
      >
        플랜 이용 기간 만료 안내
      </p>

      <div style={{ height: "20px" }} />
      <p className="center">
        플랜 이용 기간이 만료되어 서비스를 이용하실 수 없습니다.{" "}
      </p>
      <p className="center">이어서 이용하시려면 아래 문의처로 문의해주세요.</p>

      <div style={{ height: "20px" }} />
      <div className="addressBox center">info@runpoint.co.kr</div>
    </Box>
  );
};

const PlanExpired = ({ closeModal }) => {
  return <LayoutModal Modal={<PlanExpiredBox closeModal={closeModal} />} />;
};

const Box = styled.div`
  width: 400px;
  height: 230px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 30px;
  z-index: 10;

  font-family: "notoSans";
  font-size: 16px;
  color: #222222;
  .addressBox {
    width: 400px;
    height: 63px;
    border-radius: 20px;
    background-color: #f5f5f5;
    font-family: "notoSans-medium";
  }
`;

export default PlanExpired;
